import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.scss'
import { CookiesProvider } from 'react-cookie';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </CookiesProvider>
  </React.StrictMode>
);
